module.exports = __webpack_public_path__ + "img/tarj2-2.9912f734.svg";